import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { RibbonMarquee } from "@/components/site/RibbonMarquee";
import { Philosophy } from "@/components/site/Philosophy";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Contact } from "@/components/site/Contact";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = setTimeout(() => {
      const el = document.querySelector(hash);
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
      else el.scrollIntoView({ behavior: "smooth" });
    }, 400);
    return () => clearTimeout(id);
  }, [hash]);

  return (
    <>
      <Hero />
      <RibbonMarquee />
      <Philosophy />
      <About />
      <Services />
      <Contact />
    </>
  );
}
